import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { UsersService } from '../_services/users.service';
import { LoggerService } from '../../core/logger/global-logger.service';
import { SharedCallsService } from '../../shared/services/shared-calls.service';

@Component({
  selector: 'app-add-edit-users',
  templateUrl: './add-edit-users.component.html',
  styleUrls: ['./add-edit-users.component.scss']
})
export class AddEditUsersComponent implements OnInit, AfterViewInit {
  form: FormGroup;
  usersList = [];
  userRoleDropdown = { options: [] };
  defaultOption = {
    value: '-1',
    text: ' Select One',
    isSelected: true
  };
  searchTerm: string;
  isEdit: boolean;
  selectedUser: any;
  selectedRole: any;
  @Input() userDetail;
  @Input() roles;
  @Output() saveModalEmitter = new EventEmitter<any>();
  enableContinue = false;
  initialUserRole: string;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private usersService: UsersService,
    private logger: LoggerService,
    private sharedCallsService: SharedCallsService) {
  }

  ngOnInit() {
    this.isEdit = this.checkEditMode();
    this.createUsersForm();
  }

  ngAfterViewInit() {
    const usersCombobox = document.getElementById('users');
    if (usersCombobox !== undefined && usersCombobox !== null) {
      Observable.fromEvent(usersCombobox, 'keyup').debounceTime(1500).subscribe(res => {
        this.filterChange(this.searchTerm);
      });
      if (this.isEdit && this.userDetail.emailId) {
        this.filterChange(this.userDetail.emailId.trim());
      }
    }
  }

  selectionChange(value: any): void {
    if (this.selectedRole === null || this.selectedRole === undefined || this.selectedRole === '') {
      this.enableContinue = false;
    } else {
      this.enableContinue = true;
    }
  }

  private checkEditMode() {
    if (this.userDetail === null || this.userDetail === undefined) {
      return false;
    } else {
      return true;
    }
  }

  createUsersForm() {
    this.form = this.formBuilder.group({
      users: new FormControl({ value: this.selectedUser, disabled: this.isEdit }, Validators.required),
      userRole: new FormControl(this.selectedRole, Validators.required)
    });
    this.populateRoles();
    if (this.isEdit) {
      this.initialUserRole = this.userRoleDropdown.options.filter(item => item.isSelected === true)[0].value;
    }
  }

  updateSearchTerm($event: string) {
    this.searchTerm = $event;
  }

  private filterChange(filter: any): void {
    if (filter.length >= 3) {
      this.sharedCallsService.getUsers(filter.toLowerCase()).subscribe(res => {
        this.usersList = res;
        if (this.isEdit) {
          this.selectedUser = this.usersList[0];
        }
      });
    }
  }

  populateRoles() {
    if (this.userDetail && this.userDetail.roleName === 'Default') {
      this.defaultOption.isSelected = this.isEdit;
    } else {
      this.defaultOption.isSelected = !this.isEdit;
    }
    this.userRoleDropdown.options.push(this.defaultOption);
    for (const role of this.roles) {
      const roleOption = {
        value: role.id,
        text: role.name,
        isSelected: (this.isEdit && role.id === this.userDetail.roleId ? true : false)
      };
      this.userRoleDropdown.options.push(roleOption);
    }
  }

  saveUser() {
    let userObj;
    if (!this.isEdit) {
      userObj = {
        'userId': 0,
        'email': this.selectedUser.email,
        'roleId': this.selectedRole
      };
    } else {
      userObj = {
        'userId': this.userDetail.id,
        'email': this.selectedUser.email,
        'roleId': this.selectedRole
      };
    }
    this.usersService.addUser(userObj).subscribe(response => {
      this.saveModalEmitter.emit(response);
      this.activeModal.close();
      if (response && !this.isEdit) {
        this.showToaster('Success', 'User Added Successfully');
      } else if (response && this.isEdit) {
        this.showToaster('Success', 'User Updated Successfully');
      } else {
        if (this.isEdit) {
          this.showToaster('Error', 'User update was not successful');
        } else {
          this.showToaster('Error', 'User was not added Successfully ');
        }
      }
    });
  }

  checkContinueButton(roles?: any) {
    if (roles) {
      if (roles.value !== '-1' && (!this.isEdit || this.initialUserRole !== roles.value) && this.selectedUser) {
        this.enableContinue = true;
      } else {
        this.enableContinue = false;
      }
    } else { // user can come here only in case of add user
      if (this.selectedUser && this.selectedRole && this.selectedRole.value !== '-1' && !this.isEdit) {
        this.enableContinue = true;
      } else if (this.selectedUser === undefined) {
        this.enableContinue = false;
        this.activeModal.dismiss();
      } else {
        this.enableContinue = false;
      }
    }
  }

  dismissModal() {
    this.activeModal.dismiss();
  }

  private showToaster(type: string, msg: string) {
    if (type === 'Success') {
      this.logger.success({ message: msg }, true, false);
    } else {
      this.logger.warning({ message: msg }, true, false);
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/users/add-edit-users/add-edit-users.component.ts